import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/HomePage.vue'
import PresetShop from '../views/PresetShop.vue'
import PhotoDetail from '../views/PhotoDetail.vue'

const routes = [
    { path: '/', component: Home },
    { path: '/preset-shop', component: PresetShop },
    { path: '/photo-detail', component: PhotoDetail  }
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

export default router
